import { Box, Typography, useTheme } from '@mui/material';
import { MdForwardToInbox } from 'react-icons/md';
import Header from '@/Components/MagicLink/Header';
import RequestCard from '@/Components/MagicLink/RequestCard';
import PrimaryActionButton from '@/Components/MagicLink/PrimaryActionButton';
import IdCardIcon from '@/Components/MagicLink/IdCardIcon';
import MagicLinkActionBar from '@/Components/MagicLink/MagicLinkActionBar';
import { useMagicLinkAppProvider, MagicLinkView } from '@/Provider/MagicLinkAppProvider';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const IdCardUploadedSuccefullyView = () => {
    const { requestDetail, navigateToView } = useMagicLinkAppProvider();
    const theme = useTheme();

    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered hero block — logo sits at the top of the group so it is
                        always rendered directly above the success content. */}
                    <Box sx={{ ...magicLinkCenteredHeroInnerSx, gap: 3 }}>
                        <Header />

                        <Box sx={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <Box
                                sx={{
                                    color: theme.palette.success.main,
                                    '& svg path': {
                                        fill: 'currentColor'
                                    }
                                }}
                            >
                                <IdCardIcon height={45} width="auto" />
                            </Box>
                            <Typography variant="h3" component="h1" gutterBottom>
                                Občiansky preukaz úspešne nahraný
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Ďakujeme za nahratie občianskeho preukazu. Môžete pokračovať v potvrdení žiadosti.
                            </Typography>
                        </Box>

                        {requestDetail && (
                            <Box sx={{ width: '100%' }}>
                                <RequestCard
                                    icon={MdForwardToInbox}
                                    headline={requestDetail.headline}
                                    description={requestDetail.description}
                                    attachmentCount={requestDetail.attachmentCount}
                                    attachmentCountLabel={requestDetail.attachmentCountLabel}
                                    onClick={() => navigateToView(MagicLinkView.REQUEST_DETAIL)}
                                />
                            </Box>
                        )}

                    </Box>

                    <MagicLinkActionBar primary={<PrimaryActionButton fullWidth />} />
            </Box>
        </Box>
    );
};

export default IdCardUploadedSuccefullyView;
